window.addEventListener('message', (e) => {
  if (e.origin.includes('interhome')) {
    const { data } = e;
    const height = data.split(';')[0];
    $('[data-role="iframe"]').height(height);
  }
}, false);



// WEBPACK FOOTER //
// ./scripts/utils/resize-iframe.js